

// import React, { useState } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   CircularProgress,
//   Alert,
//   Paper,
// } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import axios from "axios";

// export default function Promotions() {
//   const [message, setMessage] = useState("");
//   const [phoneNumbers, setPhoneNumbers] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [alert, setAlert] = useState({ type: "", text: "" });

//   const handleSend = async () => {
//     if (!message.trim()) {
//       setAlert({ type: "error", text: "Please enter a message first." });
//       return;
//     }

//     setLoading(true);
//     setAlert({ type: "", text: "" });

//     try {
//       // Example API endpoint — replace with your actual SMS API
//       await axios.post("https://your-sms-api-endpoint.com/sendSMS", {
//         message,
//         phoneNumbers, // could be comma-separated list or array
//       });

//       setAlert({ type: "success", text: "Promotional SMS sent successfully!" });
//       setMessage("");
//       setPhoneNumbers("");
//     } catch (error) {
//       setAlert({
//         type: "error",
//         text: "Failed to send SMS. Please try again later.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         minHeight: "100vh",
//         backgroundColor: "#fff",
//         p: 2,
//       }}
//     >
//       <Paper
//         elevation={6}
//         sx={{
//           p: 4,
//           borderRadius: 4,
//           width: "100%",
//           maxWidth: 500,
//           backgroundColor: "#fff",
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             mb: 3,
//             fontWeight: "bold",
//             color: "#c19244",
//             textAlign: "center",
//           }}
//         >
//           Send Promotional SMS
//         </Typography>

//         {alert.text && (
//           <Alert
//             severity={alert.type}
//             sx={{
//               mb: 2,
//               borderRadius: 2,
//               color: "white",
//               backgroundColor:
//                 alert.type === "success" ? "#2e7d32" : "#d32f2f",
//             }}
//           >
//             {alert.text}
//           </Alert>
//         )}

//         {/* <TextField
//           label="Customer Phone Numbers (comma separated)"
//           fullWidth
//           value={phoneNumbers}
//           onChange={(e) => setPhoneNumbers(e.target.value)}
//           variant="outlined"
//           sx={{ mb: 2 }}
//         /> */}

//         <TextField
//           label="Promotion Message"
//           fullWidth
//           multiline
//           rows={4}
//           value={message}
//           onChange={(e) => setMessage(e.target.value)}
//           variant="outlined"
//           sx={{ mb: 3 }}
//         />

//         <Button
//           fullWidth
//           variant="contained"
//           disabled={loading}
//           onClick={handleSend}
//           sx={{
//             py: 1.2,
//             backgroundColor: "#c19244",
//             color: "#000",
//             fontWeight: "bold",
//             borderRadius: 2,
//             "&:hover": {
//               backgroundColor: "#b1813d",
//             },
//           }}
//           endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
//         >
//           {loading ? "Sending..." : "Send SMS"}
//         </Button>
//       </Paper>
//     </Box>
//   );
// }

import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";

export default function Promotions({ open, onClose }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", text: "" });

  const handleSend = async () => {
    if (!message.trim()) {
      setAlert({ type: "error", text: "Please enter a message first." });
      return;
    }

    setLoading(true);
    setAlert({ type: "", text: "" });

    try {
      // Send the message to your backend API
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/send-marketing-messages`,
        { message } // send as JSON body
      );
      setAlert({ type: "success", text: "Promotional SMS sent successfully!" });
      setMessage("");
    } catch (error) {
      console.error(error);
      setAlert({
        type: "error",
        text: "Failed to send SMS. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, p: 1.5, backgroundColor: "#fff" },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          color: "#c19244",
          fontSize: "1.4rem",
        }}
      >
        Send Promotional SMS
      </DialogTitle>

      <DialogContent>
        {alert.text && (
          <Alert
            severity={alert.type}
            sx={{
              mb: 2,
              borderRadius: 2,
              backgroundColor:
                alert.type === "success" ? "#2e7d32" : "#d32f2f",
              color: "white",
            }}
          >
            {alert.text}
          </Alert>
        )}

        <Typography variant="body2" sx={{ mb: 1, color: "#555" }}>
          Enter your promotion message below
        </Typography>

        <TextField
          label="Message"
          fullWidth
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#c19244" },
              "&:hover fieldset": { borderColor: "#b1813d" },
              "&.Mui-focused fieldset": { borderColor: "#c19244" },
            },
            "& .MuiInputLabel-root": { color: "#c19244" },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#c19244",
            color: "#c19244",
            fontWeight: "bold",
            "&:hover": {
              borderColor: "#b1813d",
              color: "#b1813d",
            },
          }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSend}
          disabled={loading}
          sx={{
            backgroundColor: "#c19244",
            color: "#000",
            fontWeight: "bold",
            borderRadius: 2,
            "&:hover": { backgroundColor: "#b1813d" },
          }}
          endIcon={loading ? <CircularProgress size={20} /> : <SendIcon />}
        >
          {loading ? "Sending..." : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
